/* 
  SIMPLE INFINITE SCROLL 
  1. Waits for page load (stable layout).
  2. Loads all remaining pages immediately.
  3. Re-initializes the animation observer ONCE for the whole grid.
*/

window.addEventListener('load', async () => {
  const sentinel = document.getElementById('infinite-scroll-sentinel');
  const grid = document.getElementById('product-grid');

  if (!sentinel || !grid) return;

  const currentPage = parseInt(sentinel.dataset.currentPage) || 1;
  const totalPages = parseInt(sentinel.dataset.totalPages) || 1;

  // If only 1 page, do nothing
  if (totalPages <= 1) {
    sentinel.remove();
    document.querySelector('.wt-pagination-wrapper')?.remove();
    return;
  }

  // 1. Load ALL remaining pages immediately
  async function loadAllPages() {
    for (let i = currentPage + 1; i <= totalPages; i++) {
      try {
        const url = new URL(window.location);
        url.searchParams.set('page', i);
        
        const res = await fetch(url, { headers: { 'Accept': 'text/html' } });
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        
        const newGrid = doc.getElementById('product-grid');
        if (!newGrid) continue;

        // Get items, filter out sentinel/pagination
        const items = Array.from(newGrid.querySelectorAll('.collection__grid__item'))
          .filter(el => el.id !== 'infinite-scroll-sentinel' && !el.closest('.wt-pagination-wrapper'));

        // Append to main grid
        items.forEach(el => grid.appendChild(el));
        
        // Small delay to prevent UI freeze
        await new Promise(r => setTimeout(r, 50));

      } catch (e) {
        console.error('Load error:', e);
      }
    }

    // 2. CLEANUP: Remove sentinel and pagination
    sentinel.remove();
    document.querySelector('.wt-pagination-wrapper')?.remove();

    // 3. THE MAGIC STEP: Re-initialize the observer for the ENTIRE grid.
    // This creates a FRESH observer that sees all elements (Page 1 + loaded) 
    // in their final, stable state.
    if (typeof window.initializeScrollAnimationTrigger === 'function') {
      window.initializeScrollAnimationTrigger(grid);
    }
  }

  loadAllPages();
});